import type { DriverRankingFilterEntity } from '../../domain/entities/DriverRankingFilterEntity'

export class DriverRankingFilterModel {
  regionId?: number
  rankingPeriodIds?: string[]
  tierName?: string
  driverId?: number
  driverName?: string
  page?: number
  limit?: number

  constructor(data: DriverRankingFilterEntity) {
    this.regionId = data.region?.id
    this.driverId = data.driver?.id
    this.driverName = data.driverName
    this.tierName = data.tierName
    this.page = data.page !== undefined ? data.page + 1 : undefined
    this.limit = data.limit
    this.rankingPeriodIds = data.rankingPeriods?.map((item) => item.id!).filter(Boolean)
  }
}
